import {observer} from "mobx-react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import {NavLink} from "react-router-dom";
import {ReactComponent as IconHamburger} from "assets/img/hamburger_btn.svg";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import {PropsWithChildren} from "react";
import {INavigationRoute} from "data/types/navigation";
import IconButton from "@mui/material/IconButton";
import {Typography} from "@mui/material";
import styled from "@emotion/styled";
import {LocalizationButton} from "views/components/localization_button/localization_button.component";
import shouldForwardProp from "@emotion/is-prop-valid";

const Wrapper = styled.div`
	--backgroundMenu: radial-gradient(
		ellipse,
		rgba(9, 11, 15, 0.9) 0%,
		rgba(9, 11, 15, 0.9) 62%,
		rgba(0, 0, 0, 0) 100%
	);
`;

const ListItemStyled = styled(ListItem, {shouldForwardProp})<{animationIndex: number}>`
	@keyframes animationMenuItem {
		0% {
			opacity: 0;
			top: 100px;
		}
		75% {
			opacity: 0.5;
			top: 0;
		}
		100% {
			opacity: 1;
		}
	}
	opacity: 0;
	animation: animationMenuItem 0.3s ease forwards ${(props) => props.animationIndex * 100 + 500}ms;

	a.action p {
		color: rgb(132, 137, 144);
	}
`;

const RouteItem: React.FC<PropsWithChildren> = ({children}) => {
	return (
		<ListItemText disableTypography={true}>
			<Typography
				sx={{
					fontWeight: "400",
					fontSize: "24px",
					color: "rgb(132, 137, 144)",
					".active &": {
						color: "#fff",
					},
				}}>
				{children}
			</Typography>
		</ListItemText>
	);
};

interface IProps {
	toggleMenu: () => void;
	menuState: boolean;
	routes: INavigationRoute[];
}

export const DrawerComponent: React.FC<IProps> = observer(({toggleMenu, menuState, routes}) => {
	return (
		<Wrapper>
			<IconButton
				size="large"
				aria-controls="menu-appbar"
				aria-haspopup="true"
				aria-label={"Open menu"}
				onClick={toggleMenu}
				color="inherit">
				<IconHamburger />
			</IconButton>

			<Drawer
				anchor={"right"}
				open={menuState}
				onClose={toggleMenu}
				closeAfterTransition={true}
				PaperProps={{
					sx: {
						background: "rgba(9, 11, 15, 0.9)",
						color: "#fff",
						backgroundRepeat: "no-repeat",
						backgroundSize: 0,
						width: "300px",
						animation: "backgroundSize 1.5s ease forwards",
					},
				}}>
				<IconButton
					size="large"
					aria-controls="menu-appbar"
					aria-haspopup="true"
					onClick={toggleMenu}
					sx={{
						marginLeft: "auto",
						marginTop: "10px",
						marginRight: "10px",
					}}
					color="inherit">
					<IconHamburger />
				</IconButton>

				<Box
					onClick={toggleMenu}
					onKeyDown={toggleMenu}
					sx={{
						padding: "50px 30px 0",
					}}>
					<List
						sx={{
							display: "flex",
							flexFlow: "column",
							gap: "40px",
						}}>
						{routes.map((route, index) => (
							<ListItemStyled key={index} disablePadding animationIndex={index + 1}>
								{route.external ? (
									<ListItemButton
										href={route.path}
										component={"a"}
										target={"_blank"}
										aria-label={"Link opens in new tab"}>
										<RouteItem>{route.label}</RouteItem>
									</ListItemButton>
								) : (
									<ListItemButton
										className={route.onClick ? "action" : ""}
										onClick={route.onClick}
										to={route.path}
										LinkComponent={NavLink}
										component={NavLink}>
										<RouteItem>{route.label}</RouteItem>
									</ListItemButton>
								)}
							</ListItemStyled>
						))}
					</List>
				</Box>
				<LocalizationButton />
			</Drawer>
		</Wrapper>
	);
});
